import React from "react";

import CommonSection from "../components/UI/CommonSection";
import Helmet from "../components/Helmet/Helmet";
import AboutSection from "../components/UI/AboutSection";
import { Container, Row, Col } from "reactstrap";
import BecomeDriverSection from "../components/UI/BecomeDriverSection";
import Testimonial from "../components/UI/Testimonial";
import img3 from "../assets/all-images/HR1.jpeg";
// import driveImg from "../assets/all-images/driver.jpeg";
import OurMembers from "../components/UI/OurMembers";
import "../styles/about.css";

const About = () => {
  return (
    <Helmet title="About">
      <CommonSection title="About Us" />
      

      <section className="about__page-section">
        <Container>
        <Row>
                    <Col lg="6" md="8" sm="15" className="mt-5">
                    <h6 className="section__subtitle">
                    Welcome to Viyu Group,
                      </h6>
                      <h4 className="section__title pt-2  ">
                      HR Solutions Company
                      </h4>
          
                      <p className="section_description mt-4 "> Here we understand that people are the heart of every successful organization. In today’s dynamic business environment, effective human resources management is more critical than ever. 
                        Our mission is to empower organization like yours with tailored HR solutions that not only enhance workforce performance but also drive your business success.</p>
                        <p className="section_description mt-4 ">In addition to HR services, we are passionate about investing in the future of the community hence our scholarship assistance program is designed to help student navigate the complex world of educational funding.
                           We provide personalized guidance to help student identify and apply for scholarships opportunities that align with their goals and aspirations.</p>
                           <p className="section_description mt-4 ">Whether you are a business looking to enhance workforce or a student seeking scholarships opportunities around the world, Viyu Group is here to help you succeed. Join us on the journey towards growth and success.</p>
                    </Col>
                    <Col lg="6" md="6" sm="10" className="become__driver-img pb-5 pl-5">
                      <img src={img3} alt="" className="w-60 h-70" />
                    </Col>
                  </Row>
                  <br />
                  <br />

          <div className="secContent flex">
              <div className="about__page-content">
                <h2 className="head">
                  Our Vision
                </h2>

                <p className="section_description">
                Leading with cutting edge HR technologies and services and 
                Focus on empowering students and professionals.
                </p>
               
                </div>
               
              <div className="about__page-content">
                <h2 className="head">
                  Our Mission
                </h2>

                <p className="section_description">
                To empower companies by providing compressive HR solutions and
                 to facilitating access to educational opportunities.
                </p>
              </div>
                </div>
           
        </Container>
      </section>

      <br /> <br />
     

      <section>
        <Container>
          <Row>
            <Col lg="12" className="mb-5 text-center">
              
              <h4 className="section__title">Our Members</h4>
            </Col>
            <Testimonial />
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default About;